import {Company,UserCompany} from '../companies';
import {Partner} from './partner';

export interface User {
  id: number;
  email: string;
  roleId: number;
  partnerId: number;
  companies: Company[];
  partner: Partner;
  userCompanies?: UserCompany[];
  /** Rol de usuario con sus permisos, tal y como lo sirve identity (`MinUserRoleDto`). */
  role?: UserRoleWithPermissions;

  // Campos de utils solo de frontend
  viewAdministracion: boolean;
  viewMaestros: boolean;
  viewOnlyDriversEquipmentsMaestros: boolean;
  viewEquipmentMaestro: boolean;
  manageEquipmentMaestro: boolean;
  viewDriverMaestro: boolean;
  manageDriverMaestro: boolean;
  viewMoneyData: boolean;
  viewUnassignedProjectsAndServices: boolean;
  editProject: boolean;
  createContainers: boolean;
  editService: boolean;
  generateOrders: boolean;
  validateOrders: boolean;
  approveOrders: boolean;
  uploadDocumentsUnlimited: boolean;
  validateDocuments: boolean;
  uploadDocumentsLimited: boolean;
  editSOLimited: boolean;
  editSOUnlimited: boolean;
  viewAndEditTransportSectionSO: boolean;
  editSOAdminProveedor: boolean;
  canMassiveAssignSO: boolean;
  assignEquipments: boolean;
  createProject: boolean;
  createService: boolean;
}

export interface UserCreate {
  email: string;
  roleId: number;
  partnerId: number;
}


export interface UserCreate {
  email: string;
  roleId: number;
  partnerId: number;
}

export interface UserRole {
  id: number;
  name: string;
}

/**
 * Permiso de un rol de usuario (`MinRolePermissionDto`). `scope` dice hasta dónde llega:
 * a las entidades propias o a todas. Llega como número (`PermissionScopeEnum`) salvo que
 * el backend serialice los enum como texto, así que se aceptan las dos formas.
 */
export interface UserRolePermission {
  entityType: string;
  action: string;
  scope?: number | string;
}

export interface UserRoleWithPermissions {
  role: string;
  rolePermissions?: UserRolePermission[];
}
